import { GenIcon } from '../helpers/IconBase.es.js';

const TreeviewOutlined = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 24 24", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M23.5 12.9998C23.5 13.552 23.0523 13.9998 22.5 13.9998H14C12.3431 13.9998 11 12.6566 11 10.9998V1.5C11 0.947715 11.4477 0.5 12 0.5C12.5523 0.5 13 0.947715 13 1.5V10.9998C13 11.552 13.4477 11.9998 14 11.9998H22.5C23.0523 11.9998 23.5 12.4475 23.5 12.9998Z",
          fill: "#82869E"
        }
      }
    ]
  })(props);
};

export { TreeviewOutlined };
